import React from 'react';
import { Upload, message } from 'antd';
import { Storage } from 'aws-amplify';
import compose from 'lodash/flowRight';
import { graphql } from 'react-apollo';
import { getImageType } from '../../../../core/utils/general/strings';

import CREATE_MEDIA_ADMIN from '../../../../core/GraphQl/Mutations/CREATE_MEDIA_ADMIN';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { campaignTypeMap } from '../../../../core/utils/constants/constants';
import { getUploadedFileDimensions } from '../../../../core/utils/dataManipulating/images';

const { Dragger } = Upload;

const DragUploader = ({
  adUnit,
  createMediaMutation,
  index,
  loading,
  disabled,
  onChange,
  bulkCreateCreatives,
  type: campaignType,
}) => {
  const results = [];
  const invalidMedias = [];
  const uploaderProps = {
    name: 'file',
    action: null,
    multiple: true,
    beforeUpload: async (file, fileList) => {
      try {
        onChange('loading', true);

        const { name, type, size } = file;

        if (campaignType !== campaignTypeMap.VIDEO && type === 'video/mp4') {
          message.destroy();
          message.error('File must be an image');
          return;
        }

        if (campaignType === campaignTypeMap.VIDEO && type !== 'video/mp4') {
          message.destroy();
          message.error('File must be mp4');
          return;
        }

        if (size > 2000000) {
          message.destroy();
          message.error("File can't exceed 2MB");
          return;
        }

        // Read image dimensions for the media record (videos have no dimensions)
        let imageWidth = 0;
        let imageHeight = 0;

        if (campaignType !== campaignTypeMap.VIDEO) {
          const dimensions = await getUploadedFileDimensions(file);
          imageWidth = dimensions.width;
          imageHeight = dimensions.height;
        }

        const fname = file.name + new Date();
        const response = await Storage.put(fname, file, {
          contentType: 'image/*',
        });
        const { key } = response;
        const url = await Storage.get(response.key, { expires: 600000 });

        // Put S3 image into MySQL DB with corrected dimensions
        results.push(
          createMediaMutation({
            variables: {
              mediatype: 'STILL',
              key,
              url,
              width: imageWidth,
              height: imageHeight,
              name,
              size,
              fileType: getImageType(type),
            },
          })
        );

        if (results.length === fileList.length) {
          Promise.all(results).then(async (values) => {
            const medias = values.map((value) => {
              if (value && value.data && value.data.createMedia) {
                const media = value.data.createMedia;
                delete media.id;
                delete media.__typename;
                return {
                  ...media,
                  type: 'STILL',
                };
              } else {
                return null;
              }
            });

            const validFiles = fileList.filter((fList) => !invalidMedias.includes(fList.uid));

            if (medias.length === validFiles.length) {
              message.destroy();
              bulkCreateCreatives({
                medias,
                invalidMedias: invalidMedias,
                adUnitIndex: index,
              });
            }
          });
        }
      } catch (error) {
        message.error('Error uploading file');
      } finally {
        onChange('loading', false);
      }
    },
    showUploadList: false,
    accept: '.png, .jpeg, .jpg, .gif, .avif',
    customRequest: async () => {
      setTimeout(() => {
        return true;
      }, 0);
    },
  };
  return (
    <Dragger disabled={disabled || false} {...uploaderProps}>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <p>Drag a file to this area to upload a banner.</p>
    </Dragger>
  );
};

export default compose(graphql(CREATE_MEDIA_ADMIN, { name: 'createMediaMutation' }))(DragUploader);
